/**
 * The digest a server render's error carries when our API could not be
 * reached (lib/seo/api.ts: a timeout, a network error or a 502/503/504,
 * twice in a row). Next.js keeps a digest an error already has, so it
 * reaches the browser unchanged: the error page (app/error.tsx) says the
 * page is temporarily unavailable and tries again by itself, and the
 * Worker gateway (worker/index.ts) answers the document with a 503 that
 * nothing keeps instead of a 500.
 *
 * The render throws, it never draws the state itself: an ISR page that
 * rendered "unavailable" would be cached as the page for up to a week,
 * while Next never caches a render that threw (checked on Next 16.4.2,
 * 2026-11-01). Free of imports: the Worker bundle, the server and the
 * browser all read it.
 */
export const UNAVAILABLE_DIGEST = "MENZIL_UNAVAILABLE";
